interface SectionHeaderProps {
  children: React.ReactNode;
}

export default function SectionHeader({ children }: SectionHeaderProps) {
  return <h1 className="mb-6 text-form-title">{children}</h1>;
}
